import { useIntl } from 'react-intl';

export default function SegnalazioniHead() {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-segnalazioni-head-head" style={{ display: 'contents' }}>
      <>
        <div className="row m-0 wrapper w-100">
          <div className="col-12 col-md-10 offset-md-1">
            <div className="row">
              <div className="col-12 snf-font-32 snf-font-w6 mb-4">
                {intl.formatMessage({
                  defaultMessage: 'Segnalazione di condotte illecite – Whistleblowing'
                })}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <p className="snf-font-w6 snf-font-16 mb-2">
                  {intl.formatMessage({
                    defaultMessage: 'Canale di segnalazione ai sensi del D. Lgs. n. 24/2023'
                  })}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <p className="snf-font-16 mb-2">
                  {intl.formatMessage({
                    defaultMessage:
                      'Grazie per il tuo interesse nel voler condividere con noi le tue segnalazioni.'
                  })}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 snf-font-16 mb-3">
                {intl.formatMessage(
                  {
                    defaultMessage: `Come previsto dal Decreto Legislativo 10 marzo 2023 n. 24, in materia di Whistleblowing, <b>Sistemi Informativi S.r.l.</b> mette a tua disposizione il canale di segnalazione “Confidentially Speaking – Whistleblowing”, contattabile nelle modalità di seguito indicate, a cui puoi fare riferimento secondo quanto previsto di seguito.`
                  },
                  {
                    b: (chunks) => <b>{chunks}</b>
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
